module.exports = __webpack_public_path__ + "static/media/check.7aafbdc3.jpg";